﻿import { defineComponent } from 'vue';

import itinerary_breakdown from "../common/itinerary_breakdown.vue"
import trip_summary from "../common/trip_summary.vue"

import { Booking } from "../../../services/booking";
import { Date_Service } from "../../../../system/services/date_service";
import { Currency_Service } from "../../../../system/services/currency";

const Book: Booking = new Booking();
const Currency_Services: Currency_Service = new Currency_Service();
const Date_Services: Date_Service = new Date_Service();

export default defineComponent({
    name: "summary",
    components: {
        itinerary_breakdown,
        trip_summary
    },
    props: {
    },
    data() {
    },
    methods: {
        get_total_outstanding(): string {
            return Currency_Services.Format_Currency(Book.get_total_outstanding(this.$store.getters.get_Booking), this.$store.getters.get_Currency);
        },
        Balance_Outstanding(): boolean {
            return Book.get_total_outstanding(this.$store.getters.get_Booking) > 0;
        },
        Balance_Due_Date(): string {
            return Date_Services.full_date(Book.get_Expiry_Date(this.$store.getters.get_Booking));
        },
        get_Currency(): string {
            return this.$store.getters.get_Currency.currency_info.iso_currency_code;
        },
        get_Total_Price(): string {
            return Currency_Services.Format_Currency(Book.get_total_price(this.$store.getters.get_Booking, this.$store), this.$store.getters.get_Currency);
        },
        redirect_to_paymentpage() {
            this.$router.push({ path: "/creditcard" });
        },
        get_Departure_Date(): string {
            return Date_Services.output_date(this.$store.getters.get_Booking?.trips[0].departure_date);
        },
        get_tourIds(): string {
            const booking = this.$store.getters.get_Booking;
            if (!booking || !Array.isArray(booking.trips)) {
            return "";
            }
            let tourIds = booking.trips
            .filter((trip: any) => trip && trip.tour_id)
            .map((trip: any) => trip.tour_id)
            .join(",");

            //META PIXEL CONDITIONS
            // This should be removed once the new system dashboard is created
            let winterTourIds = ["I3B", "ABE", "X5P", "3H1", "H52"];
            if (winterTourIds.some(id => tourIds.toUpperCase().includes(id))) {
                tourIds += ",WINTER_TOUR_PURCHASE";
            }

            let dateSpecificWinterTourIds = ["IV6", "HXN", "IV5", "OT1", "HXF"];
            const hasDateSpecificWinterTour = dateSpecificWinterTourIds.some(id => tourIds.toUpperCase().includes(id));
            if (hasDateSpecificWinterTour) {
                const departureDateStr = this.get_Departure_Date?.() ?? "";

                const parseYMD = (str: string): Date | null => {
                    const m = /^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})$/.exec(str.trim());
                    if (!m) return null;
                    const y = Number(m[1]);
                    const mo = Number(m[2]) - 1;
                    const d = Number(m[3]);
                    const dt = new Date(y, mo, d);
                    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) return null;
                    return dt;
                };

                const departureDate = departureDateStr ? parseYMD(departureDateStr) : null;

                if (departureDate) {
                    const month = departureDate.getMonth();
                    const isWinterWindow = month === 10 || month === 11 || month === 0 || month === 1 || month === 2;
                    if (isWinterWindow) {
                        tourIds += ",WINTER_TOUR_PURCHASE";
                    }
                }
            }

            
            return tourIds;
        },
        redirect_with_tourIds() {
            const tourIds = this.get_tourIds();
            const currentPath = this.$route.path;
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    ...(tourIds ? { tours: tourIds } : {})
                }
            });
        },
        Get_Paid(): number {
            return Book.get_Paid(this.$store.getters.get_Booking);
        },
        is_fully_paid(): boolean {
            return !this.Balance_Outstanding();
        },
        is_part_paid(): boolean {
            return this.Get_Paid() > 0 && this.Balance_Outstanding();
        },
        is_not_paid(): boolean {
            return this.Get_Paid() === 0 && this.Balance_Outstanding();
        },
    },
    mounted() {
        this.redirect_with_tourIds();
    }
})